const invites = state => state.invites
const isLoading = state => state.isLoading
const hasError = state => state.error !== null
const error = state => state.error
const hasInvites = state => state.invites.length > 0

export default {
  invites, isLoading, hasError, error, hasInvites,
}
